import logoIcon from 'assets/images/logo/aram-icon.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <img src={logoIcon} alt="Aram Icon" width="35" />
  );
}
